import { Component, computed, signal } from '@angular/core';
import { ModalService } from '@src/shared/modal/modal.service';
import { formatWooDate, isDateAfter, isDateBefore } from '../../../utils/date';
import { saveFileAs } from '../../../utils/files';
import { InitialDate } from '../../../woo_components.module/date_selectors/shared/types';
import { InvoiceService } from '../../../woo_services.module/InvoiceService';
import { Period } from '../../../woo_services.module/shared-types';

@Component({
  selector: 'invoice-tools',
  templateUrl: './invoice-tools.component.html',
  styles: [
    `
      .no-margin {
        margin: 0;
        padding-bottom: 2rem;
      }
    `,
  ],
  standalone: false,
})
export class InvoiceTools {
  readonly InitialDate = InitialDate;
  public savable = computed(() => {
    const start = this.startDate() as Date | null;
    const end = this.endDate() as Date | null;
    const min = this.firstSelectableDate as Date | null;
    if (!start || !end) return false;
    return isDateBefore(start, end) && isDateAfter(start, min) && isDateAfter(end, min);
  });

  firstSelectableDate: Date = new Date(2015, 1, 1);
  period: Period;
  startDate = signal<Date>(new Date());
  endDate = signal<Date>(new Date());

  constructor(private invoiceService: InvoiceService, private modalService: ModalService) {}

  periodChanged = (event: Period): void => {
    this.startDate.set(event.start as Date);
    this.endDate.set(event.end as Date);
  };

  async downloadInvoiceExcel(): Promise<void> {
    const progress = signal(0);
    const progressMessage = signal('Exporterar fakturor');
    const progressModal = this.modalService.openProgress('Exporterar fakturor', progress, progressMessage);
    const response = await this.invoiceService.getExcelSheet(this.date_params(), {
      progress,
      progress_message: progressMessage,
    });

    try {
      progressModal.close();
      saveFileAs(response.blob, response.name);
    } catch {
      progressModal.close();
      this.modalService.openError('Det gick inte att exportera fakturorna.');
    }
  }

  private date_params = (): Record<string, string> => {
    return {
      start_date: formatWooDate(this.startDate()),
      end_date: formatWooDate(this.endDate()),
    };
  };
}
